import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  user: any;

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    if (this.user != null && this.user.idTokenClaims != undefined) {
      let groups: string[] = this.user.idTokenClaims['groups'] as string[];
      if (
        groups.includes(environment.adminGroupID) ||
        groups.includes(environment.superAdminGroupID)
      ) {
        return true;
      } else {
        this.router.navigateByUrl('');
        return false;
      }
    } else {
      this.router.navigateByUrl('');
      return false;
    }
  }
}
